import { useState, type VoidFunctionComponent } from 'react';
import type { DependencyMetadataFilterOption, FormatName, IncludeFilterOption, LicensingFormat } from './shared/types';
import type { FormatSelection, OnApply } from './shared/components/Filter';
import Filter from './shared/components/Filter';
import { ReportCategories } from '../ReportGeneration/utils';
import type { SetState } from '../../../../types';

type LicensingFiltersProps = {
  onApply: OnApply;
  appliedFormat: FormatName | null;
  setIsDirty: SetState<boolean>;
  isApplyButtonDisabled: boolean;
  includeOptions: IncludeFilterOption[];
  dependencyMetadataOptions: DependencyMetadataFilterOption[];
};

const LicensingFilters: VoidFunctionComponent<LicensingFiltersProps> = ({
  isApplyButtonDisabled,
  onApply,
  appliedFormat,
  setIsDirty,
  includeOptions,
  dependencyMetadataOptions,
}: LicensingFiltersProps) => {
  const htmlFormat: LicensingFormat = { label: 'HTML', value: 'HTML' };
  const formats: LicensingFormat[] = [
    htmlFormat,
    { label: 'PDF', value: 'PDF' },
    { label: 'CSV', value: 'CSV' },
    { label: 'Markdown', value: 'Markdown' },
    { label: 'Plain Text', value: 'Plain Text' },
  ];
  const [format, setFormat] = useState<FormatSelection>(htmlFormat);
  return (
    <Filter
      isApplyButtonDisabled={isApplyButtonDisabled}
      includeOptions={includeOptions}
      dependencyMetadataOptions={dependencyMetadataOptions}
      category={ReportCategories.Licensing}
      appliedFormat={appliedFormat}
      format={format}
      setFormat={setFormat}
      setIsDirty={setIsDirty}
      formats={formats}
      onApply={onApply}
    />
  );
};

export default LicensingFilters;
